import { createSelector } from 'reselect';
import { FIELDS } from 'components/forms/form-fields/enum';
import { channelsSelector } from 'common/selectors/channels';
import { uploadFormConfigSelector } from 'pages/upload.page/selectors';
import { intersectionBy, get } from 'lodash-es';
import { getVideoDisplaySettingsSelector } from 'common/selectors';

export const myVideosSelector = createSelector(
  (state) => state.myVideos,
  (myVideos) => myVideos
);

export const myVideosSelectedVideoSelector = createSelector(myVideosSelector, (myVideos) => myVideos.video);

/**
 * @param {{id: number}[]} allCt
 * @param {{id: number}[]} configured
 * @param {{id: number}[]} video
 */
export const subsetSelectedChannels = (allChannels, configuredChannels, videoChannels) => {
  return intersectionBy(allChannels, configuredChannels, videoChannels, 'id').map(({ id }) => id);
};

export const myVideosEditFormState = createSelector(
  [myVideosSelectedVideoSelector, channelsSelector, uploadFormConfigSelector],
  /**
   * @param {videoModel.type} video
   * @param {channelModel.type[]} channels
   * @return {*}
   */
  (video, channels, uploadFormConfig) => {
    if (!video || !channels || !uploadFormConfig) {
      return null;
    }
    const data = {
      [FIELDS.VIDEO_TITLE]: video.title,
      [FIELDS.COUNTRY_SELECT]: video.countries,
      [FIELDS.LANGUAGE_SELECT]: video.languages,
      [FIELDS.KEYWORDS]: video.keywords,
      [FIELDS.DESCRIPTION]: video.description,
    };

    uploadFormConfig.forEach((cfg, index) => {
      if (cfg.type === FIELDS.CHANNEL_SELECT) {
        data[`${cfg.type}_${index}`] = subsetSelectedChannels(channels, cfg.config.data, video.channels);
      }
    });

    return data;
  }
);

export const myVideoDeletedVideoIdSelector = createSelector(myVideosSelector, (myVideos) => myVideos.deletedVideoId);

export const myVideosAverageRating = createSelector(myVideosSelector, (myVideos) =>
  myVideos.video ? myVideos.video.ratingAvg : 0
);

export const getMyVideoUploaderSelector = createSelector(myVideosSelector, (myVideos) =>
  get(myVideos, 'videoUploader')
);

export const getMyVideoResponsibleSelector = createSelector(myVideosSelector, (myVideos) =>
  get(myVideos, 'videoResponsibleUser')
);

export const getMyVideoResponsibleUserSelector = createSelector(
  myVideosSelector,
  getMyVideoUploaderSelector,
  getVideoDisplaySettingsSelector,
  (myVideos, videoUploader, displaySettings) => {
    const responsibleUser = get(myVideos, 'videoResponsibleUser');
    const showUploader = get(displaySettings, 'uploader');

    if (responsibleUser) {
      return responsibleUser;
    } else if (showUploader) {
      return videoUploader;
    } else {
      return null;
    }
  }
);
